import { LOCAL } from '../../constants/FJEvnConstant';

const environment = import.meta.env.MODE;

const voiceVersion = '1.0.0.7';

export default {
    currentMenuName: 'ai-text-to-speech',

    voicePath:
        environment === LOCAL
            ? `/public/resource/text-to-speech/voice.json`
            : `/app/ai-tools/resource/text-to-speech/voice.json?v=` + voiceVersion,
    voicePathOfFLEXCLIP:
        environment === LOCAL
            ? `/public/resource/text-to-speech/clone-voice.json`
            : `/app/ai-tools/resource/text-to-speech/clone-voice.json?v=` + voiceVersion,

    avatarPath:
        environment === LOCAL
            ? `/public/resource/text-to-speech/avatar/`
            : `https://resource.flexclip.com/app/ai-tools/resource/text-to-speech/avatar/`,

    voiceCloneAvatarPath:
        environment === LOCAL
            ? `/public/resource/text-to-speech/clone-voice-info/avatar/`
            : `https://resource.flexclip.com/app/ai-tools/resource/text-to-speech/clone-voice-info/avatar/`,
    voiceCloneAudioPath:
        environment === LOCAL
            ? `/public/resource/text-to-speech/clone-voice-info/audio/`
            : `https://resource.flexclip.com/app/ai-tools/resource/text-to-speech/clone-voice-info/audio/`,

    ttvProjectKey: `text-to-audio-project/`,
    microsoftKey: `ai/export/microsoft-speech/`,
    totalFreeNumCreationTextToSpeech: 4000,

    profilePath:
        environment === LOCAL ? `/public/resource/voice-clone/profile/` : `/app/ai-tools/resource/voice-clone/profile/`,
    historyListType: 26,
    originalAudioKey: 'ai/input/voice-clone/',
    resultAudioKey: 'ai/export/voice-clone/',
    NAME_MAXLENGTH: 100,
};
